<template>
  <v-app>
    <div class="reset-password">
      <v-container>
        <v-row>
          <v-col>
            <div class="circle-logo text-center pt-12">
              <logo-img></logo-img>
            </div>
            <div class="logo-img">
              <div class="text-center">
                <logo class="logo" />
                <div class="caption primary--text">Manager</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row align-content="center">
          <v-col cols="12" sm="6" offset-sm="3">
            <div class="wrapper mx-auto">
              <div class="text-center">
                <h1 class="h1">Reset Password</h1>
                <p>
                  We will send the reset password instructions to your email.
                </p>
              </div>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  type="email"
                  label="Type your email"
                  v-model="email"
                  :rules="emailRules"
                  :error-messages="error"
                  outlined
                >
                </v-text-field>

                <recaptcha
                  :data-sitekey="recaptcha_key"
                  :data-callback="recaptchaCallback"
                  :data-validate="validate"
                  :data-size="'visible'"
                  :data-btn-disabled="loading || !valid"
                  :loading="loading"
                >
                  Send
                </recaptcha>
              </v-form>

              <p class="overline mt-6">
                Already have an account?
                <router-link :to="{ name: 'Login' }">Sign In</router-link>
                <br />
                Don't have account?
                <router-link :to="{ name: 'Register' }"
                  >Create Account</router-link
                >
                <br />
                <router-link :to="{ name: 'ResendConfirmationInstructions' }">
                  Didn't receive confirmation instructions?
                </router-link>
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import Logo from "@/components/Logo";
import LogoImg from "@/components/LogoImg";
import Recaptcha from "@/components/Recaptcha";
import { requestPasswordReset } from "@/services/http/passwords";
import { emailRules } from "@/services/validators";

export default {
  name: "RequestResetPassword",
  components: {
    Logo,
    LogoImg,
    Recaptcha,
  },
  data() {
    return {
      recaptcha_key: process.env.VUE_APP_RECAPTCHA_KEY_2,
      loading: false,
      error: null,
      valid: true,
      email: "",
      emailRules,
    };
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    recaptchaCallback(token) {
      if (token) {
        this.send(token);
      } else {
        alert("Please check captcha to verify you are not a robot");
      }
    },
    async send(captcha_token) {
      try {
        if (this.$refs.form.validate()) {
          this.loading = true;
          const { id } = await requestPasswordReset(this.email, captcha_token);
          this.$router.push({ name: "ResetPassword", params: { id } });
        }
      } catch (e) {
        console.error(e);
        this.error = e.toString();
        if (window.grecaptcha) window.grecaptcha.reset();
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    email(v) {
      if (v) this.error = null;
    },
  },
};
</script>
